import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/app/(public)/profile/[username]/following/container.tsx");
